module.exports = __webpack_public_path__ + "img/about.27ee6ed6.jpg";